import eledo from "./eledo";

const GENERATE_URL = "/generate";

const generateDocument = (templateId, file) =>
  eledo.post(
    GENERATE_URL,
    JSON.stringify({ templateId, file }),
    { headers: { "Content-Type": "application/json" }, responseType: 'blob' }
  )

const generateService = { generateDocument };

export default generateService;